module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progress),
      expression: "progress"
    }],
    staticClass: "z-input-stock-zones"
  }, [_c('autocomplete', {
    ref: "search",
    attrs: {
      "property": "name",
      "return": "id",
      "label": "Добавить направление",
      "display-property": "name",
      "show-save-btn": true,
      "callback": _vm.getZones
    },
    on: {
      "select": _vm.selectZone,
      "save": _vm.addZoneToStock,
      "clear": _vm.clearSelectedZone
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), (_vm.stockZones && _vm.stockZones.length) ? _c('div', {
    staticClass: "z-input-stock-zones__cities-list-container"
  }, [_c('div', {
    staticClass: "z-input-stock-zones__cities-label"
  }, [_vm._v(_vm._s(("Прикреплённые направления (" + (_vm.stockZones.length) + ")")))]), _vm._v(" "), _c('div', {
    staticClass: "z-input-stock-zones__cities-list can-scroll"
  }, _vm._l((_vm.stockZones), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "z-input-stock-zones__cities-item"
    }, [_c('div', {
      staticClass: "value"
    }, [_vm._v(_vm._s((item.value) ? item.value : item.name))]), _vm._v(" "), _c('div', {
      staticClass: "actions"
    }, [_c('md-button', {
      staticClass: "md-icon-button md-dense small",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.showRemoveDialog(item)
        }
      }
    }, [_c('md-icon', [_vm._v("delete")])], 1), _vm._v(" "), _c('md-tooltip', {
      attrs: {
        "md-direction": "top"
      }
    }, [_vm._v("Открепить направление")])], 1)])
  }))]) : _vm._e(), _vm._v(" "), _c('md-dialog-confirm', {
    attrs: {
      "md-active": _vm.removeDialog,
      "md-title": "Открепить направление от склада?",
      "md-content": "Внимание! Действие необратимо!",
      "md-confirm-text": "Удалить",
      "md-cancel-text": "Отмена"
    },
    on: {
      "update:mdActive": function($event) {
        _vm.removeDialog = $event
      },
      "md-cancel": function($event) {
        _vm.removeDialog = false;
        _vm.zoneIdToRemove = null;
      },
      "md-confirm": _vm.removeZoneFromStock
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29252e23","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZInputStockZones.vue
// module id = 1080
// module chunks = 0